export default {"src":"/_next/static/media/information-sitter.8c57e1e6.svg","height":32,"width":37,"blurWidth":0,"blurHeight":0};